import router from './router'
import App from './App.vue'
import {createApp} from "vue"
import '@/assets/style/index.css'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import {ArrowRight} from '@element-plus/icons-vue';
import VueQrcode from 'vue-qrcode'
const app = createApp(App)
app.use(router)
    .use(ElementPlus, {locale: zhCn})
    .component('ArrowRight', ArrowRight)
    .component('vue-qrcode', VueQrcode)
    .mount('#app')
